export default "__VITE_ASSET__D4ioDopO__"